import './App.css';
import './components/styles/styles.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout
import AppLayout from "./components/AppLayout";

// Pages
import Login from './components/Login';
import ViewItems from './components/ViewItems';
import StaffChangepassword from './components/StaffChangepassword';
import AdminStaffmanagement from './components/AdminStaffmanagement';
import CustomerManagement from './components/CustomerManagement';
import SlotManagement from './components/SlotManagement';
import Serviceprovidermanagement from './components/Serviceprovidermanagement';
import ServiceManagement from './components/ServiceManagement';
import AddService from './components/AddService';
import RequestaQuote from './components/RequestaQuote';
import ItemManagement from './components/ItemManagement';
import InspectionBooking from './components/InspectionBooking';
import Demo from './components/Demo';
import Bannermanagement from './components/Bannermanagement';
import LoginStaffs from './components/LoginStaffs';
import ServiceQuote from './components/ServiceQuote';
import Dashboard from './components/Dashboard';
import ViewmoreQuotes from './components/ViewmoreQuotes';
import ServiceQuoteReport from './components/ServiceQuoteReport';
import InspectionBookingReport from './components/InspectionBookingReport';
import BlogManagement from './components/BlogManagement';
import AddBlog from './components/AddBlog';
import ReactBigCalendar from './components/ReactBigCalendar';
import NotificationCalendar from './components/NotificationCalendar';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './components/theme';  

function App() {
  return (
  <ThemeProvider theme={theme}>  
      <CssBaseline />  
    <BrowserRouter basename="/">
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes with Layout */}
        <Route element={<AppLayout />}>
          <Route path="/AdminStaffmanagement" element={<AdminStaffmanagement />} />
          <Route path="/StaffChangepassword" element={<StaffChangepassword />} />
          <Route path="/CustomerManagement" element={<CustomerManagement />} />
          <Route path="/SlotManagement" element={<SlotManagement />} />
          <Route path="/Serviceprovidermanagement" element={<Serviceprovidermanagement />} />
          <Route path="/ServiceManagement" element={<ServiceManagement />} />
          <Route path="/AddService" element={<AddService />} />
          <Route path="/RequestaQuote" element={<RequestaQuote />} />
          <Route path="/ItemManagement" element={<ItemManagement />} />
          <Route path="/InspectionBooking" element={<InspectionBooking />} />
          <Route path="/Demo" element={<Demo />} />
		  <Route path="/Bannermanagement" element={<Bannermanagement />} />
		  <Route path="/LoginStaffs" element={<LoginStaffs />} />
		  <Route path="/ServiceQuote" element={<ServiceQuote />} />
		  <Route path="/Dashboard" element={<Dashboard />} />
		  <Route path="/ViewmoreQuotes" element={<ViewmoreQuotes />} />
		  <Route path="/ServiceQuoteReport" element={<ServiceQuoteReport />} />
		  <Route path="/InspectionBookingReport" element={<InspectionBookingReport />} />
 <Route path="/BlogManagement" element={<BlogManagement />} />
 <Route path="/AddBlog" element={<AddBlog />} />
 <Route path="/ReactBigCalendar" element={<ReactBigCalendar/>} />
 <Route path="/NotificationCalendar" element={<NotificationCalendar/>} />
 <Route path="/ViewItems" element={<ViewItems/>} />
        </Route>
      </Routes>
    </BrowserRouter> </ThemeProvider>
  );
}

export default App;
